import api from './axios';

export type DepartamentoRol =
  | 'facturacion'
  | 'att_familias'
  | 'att_alumnado'
  | 'att_profesorado'
  | 'admisiones'
  | 'hr';

export interface DepartamentoManager {
  usuarioId: number;
  rol: DepartamentoRol;
  createdAt: string;
  createdBy?: number | null;
  usuario?: {
    id: number;
    email: string;
    nombreCompleto: string;
    rol: string;
  };
}

export async function listManagers(rol?: DepartamentoRol): Promise<DepartamentoManager[]> {
  const params = rol ? { rol } : {};
  const { data } = await api.get('/departamento-managers', { params });
  return Array.isArray(data) ? data : [];
}

export async function getManagersForRol(rol: DepartamentoRol): Promise<DepartamentoManager[]> {
  const { data } = await api.get(`/departamento-managers/rol/${rol}`);
  return Array.isArray(data) ? data : [];
}

export async function checkManager(usuarioId: number, rol: DepartamentoRol): Promise<boolean> {
  const { data } = await api.get(`/departamento-managers/check/${usuarioId}/${rol}`);
  return data.isManager;
}

export async function addManager(usuarioId: number, rol: DepartamentoRol): Promise<DepartamentoManager> {
  const { data } = await api.post('/departamento-managers', { usuarioId, rol });
  return data;
}

export async function removeManager(usuarioId: number, rol: DepartamentoRol): Promise<void> {
  await api.delete(`/departamento-managers/${usuarioId}/${rol}`);
}

export async function getRolesForUsuario(usuarioId: number): Promise<DepartamentoRol[]> {
  const { data } = await api.get(`/departamento-managers/usuario/${usuarioId}`);
  return Array.isArray(data) ? data : [];
}

export async function checkIsManager(): Promise<{ isManager: boolean }> {
  const { data } = await api.get('/departamento-managers/me/is-manager');
  return data;
}

export async function getMyManagerRoles(): Promise<DepartamentoRol[]> {
  const { data } = await api.get('/departamento-managers/me/roles');
  return Array.isArray(data) ? data : [];
}

